/* eslint-disable max-len */
export default {
  MESSAGES: {
    CURRENT_DELIVERY_STATUS: 'Stato attuale della consegna',
    DATE: 'Data',
    DELIVERY_HISTORY: 'Cronologia della consegna',
    HOUR: 'Ora',
    OBSERVATIONS: 'Osservazioni',
    STATUS: 'Stato'
  }
};
